import React from 'react'
import moment from 'moment'
import chartClasses from '../../stylesheets/Charts.module.css'

function EarQListRow(props) {

  // console.log("EarQListRow props", props)

    const onSelect = () => {
        props.onSelect(props.earQ)
    }

    return (
        <tr className='mx-4 px-10'>
            {props.columnMapping.map((m,i) => {
                if (m[1] !== null) {
                    const cellValue = moment(props.earQ[m[1]], moment.ISO_8601, true).isValid() ? moment(props.earQ[m[1]]).format('MM/DD/YYYY HH:mm') : props.earQ[m[1]]
                    return <td scope="row" key={i}>{cellValue}</td>
                } else {
                    return <td scope="row" key={i}><span className={chartClasses.link} onClick={onSelect}>view</span></td>
                }
            })}
        </tr>
    )
}

export default EarQListRow
